module.exports = __webpack_public_path__ + "img/title-lucky.5ab81042.png";